import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/admin/subscription-types` — dal 01-11-2026 le pagine di «Organizzazione DP» stanno tutte sotto `/organization/`.
 * L'indirizzo vecchio resta come rinvio, coi suoi parametri, per i preferiti e i collegamenti salvati.
 */
export const Route = createFileRoute('/_app/admin/subscription-types')({
  beforeLoad: ({ search }) => { throw redirect({ to: '/organization/subscription-types', search: search as never, replace: true }); },
});
